import { BillingRecurringTypes } from "./upgradable.products.response";

export enum UpgradeTypes {

    MonthToMonth = 0,
    MonthToYear = 1,
    YearToYear = 2,
    NotSupported = 99

}

export class UpgradeSimulationResponse {

    UpgradeType: UpgradeTypes;
    OldBillingCycle: BillingRecurringTypes;
    NewBillingCycle: BillingRecurringTypes;
    OldProductID: number;
    OldProductName: string;
    NewProductID: number;
    NewProductName: string;
    OldPrice: number;
    DateTimeCycleStart: Date;
    DateTimeCycleEnd: Date;
    DaysCurrentCycle: number;
    DaysUntilRenewal: number;
    DaysUsed: number;
    OldDayPrice: number;
    AmountUsedThisCycle: number;
    CreditThisCycle: number;
    NewPrice: number;
    NewDayPrice: Number;
    AmountDueThisCycleNewProduct: number;
    TotalDueUpgrade: number;
    DateTimeNewCycleEnd: Date;

    TotalDueUpgradeTaxAmount: number;
    TotalDueUpgradeWithTax: number;
    TaxRateDisplay: string;
    TaxFromCache: boolean;
    TaxEnabled: boolean;
    TaxRate: number;
    State: string;

    // public static FixDates(item: UpgradeSimulationResponse) {
    //     item.DateTimeCycleEnd = new Date(item.DateTimeCycleEnd);
    //     item.DateTimeCycleStart = new Date(item.DateTimeCycleStart);
    //     item.DateTimeNewCycleEnd = new Date(item.DateTimeNewCycleEnd);
    // }

}